import { initBillingCopyFromRegistration } from '../share/billing-copy-from-registration';

document.addEventListener('DOMContentLoaded', () => {
    initBillingCopyFromRegistration();

    const termsContent = document.getElementById('termsContent');
    const termsCheckbox = document.getElementById('termsAgreeCheck');
    const submitBtn = document.getElementById('registerSubmitBtn');

    if (!termsContent || !termsCheckbox || !submitBtn) {
        return;
    }

    const scrollThresholdPx = 5;

    /**
     * 利用規約エリアの末尾まで読んだら同意チェックボックスを活性化する。
     * 中身が短くスクロールが発生しない場合は scroll イベントが飛ばないため、初期表示とレイアウト確定後にも判定する。
     */
    function updateTermsCheckboxEnabled() {
        const scrolledToBottom =
            termsContent.scrollHeight - termsContent.scrollTop - termsContent.clientHeight <= scrollThresholdPx;

        if (scrolledToBottom) {
            termsCheckbox.disabled = false;
        }
    }

    termsContent.addEventListener('scroll', updateTermsCheckboxEnabled);
    updateTermsCheckboxEnabled();
    requestAnimationFrame(() => updateTermsCheckboxEnabled());

    // 同意チェックボックス変更時アクション
    termsCheckbox.addEventListener('change', () => {
        // 同意チェック選択判定
        if (termsCheckbox.checked) {
            // 同意の場合、登録ボタン有効化
            submitBtn.classList.remove('is-disabled');
        } else {
            // 未同意の場合、登録ボタン無効化
            submitBtn.classList.add('is-disabled');
        }
        submitBtn.disabled = !termsCheckbox.checked;
    });

    // パスワードポリシーを画面最下部へ追加
    const modal = document.getElementById('passwordPolicyModal');
    if (modal) {
        document.body.appendChild(modal);
    }
});
